export function parseStdQueryString(url) {
  // 使用 URL 对象解析 URL
  const urlObj = new URL(url);

  // 获取查询字符串
  const queryString = urlObj.search;

  // 使用 URLSearchParams 解析查询字符串
  const params = new URLSearchParams(queryString);

  // 将查询参数转换为对象
  const queryObj = {};
  for (const [key, value] of params) {
    queryObj[key] = value;
  }

  return queryObj;
}

export function parseHashQueryString(url) {
  // 提取 URL 中的查询字符串部分
  const hash = (url.split("#")[1] || "").trim();
  const qs = (hash.split("?")[1] || "").trim();

  // 将查询字符串转换为对象
  const queryObj = {};
  if (qs) {
    // const reg = new RegExp("\\s*=\\s*");
    qs.split("&").forEach((pair) => {
      const [key, value] = pair
        .trim()
        .split("=")
        .map((s) => s.trim());
      if (key) {
        queryObj[decodeURIComponent(key)] = decodeURIComponent(value || "");
      }
    });
  }

  return queryObj;
}


/**
 * 复制文案
 * @param {*} text
 */
export function copyText(text) {
  const input = document.createElement('input');
  input.setAttribute('value', text);
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}